module.exports = __webpack_public_path__ + "img/Mask_Group 818.d37432ab.png";